<template>

    <div>
        <el-card shadow="hover"  class="searchCard" >
             <span class="label-span">
                <label class="label">表名代码</label>
                <el-input v-model.trim="query.code" placeholder="表名说明" class="handle-input mr10"></el-input>
            </span>
            <span class="label-span">
                <label class="label">缓存数据周期</label>
                <el-input v-model.trim="query.yearMonth" placeholder="表名说明" class="handle-input mr10"></el-input>
            </span>
            <span class="label-span">
                <label class="label">执行状态</label>
                <el-select v-model="query.status"  placeholder="表名状态" clearable class="handle-select mr10">
                    <el-option value="" label="全部"  />
                    <el-option value="1" label="执行成功"  />
                    <el-option value="0" label="执行失败"  />
                </el-select>
            </span>
            <el-button icon="el-icon-search" class='mr10' @click="handleSearch">搜索</el-button>
            <el-button icon="el-icon-refresh" class='mr10' @click="refreshSearch">重置</el-button>
<!--            <el-dropdown class='mr10'>
                <el-button  type="primary" >批量操作 v</el-button>
                <el-dropdown-menu slot="dropdown">
&lt;!&ndash;                        <span class='tableOperBtn2' @click="updateMore">
                            <i class="el-icon-edit"></i> 批量修改
                        </span> <br>&ndash;&gt;
                    <span class='tableOperBtn2' @click="deleteMore">
                            <i class="el-icon-delete"></i> 批量删除
                        </span>
                </el-dropdown-menu>
            </el-dropdown>
            <el-button icon="el-icon-lx-roundadd" class='mr10' @click="handleAdd" >添加表名</el-button>-->



        </el-card>
        <el-card shadow="hover"  class="containCard" >
            <el-table :data="tableData" border class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  >
                <el-table-column type="selection" width="40" align="center"></el-table-column>
                <el-table-column prop="fb1" width="150" align="left"  label="缓存表名">
                    <template slot-scope="scope" >
                        <p style='line-height:30px;' v-for="item in scope.row.fb1.split(',')"><el-tag type="info" >{{item}}</el-tag></p>
                    </template>
                </el-table-column>
                <el-table-column prop="yearmonth" width="100" align="center"  label="执行年月"> </el-table-column>
                <el-table-column prop="excuteRange" width="140" align="center"  label="执行数据周期"> </el-table-column>
                <el-table-column prop="status" width="90" align="center" label="执行状态">
                    <template slot-scope="scope" >
                        <el-tag :type="scope.row.status==1?'success':'danger'">{{scope.row.status==1?'执行成功':'执行失败'}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="info" min-width="250" align="left" label="执行状态详情">
                    <template slot-scope="scope" >
                        <el-popover placement="bottom" title="详细信息"  width="600" trigger="click" :content="scope.row.info">
                            <a class="textShowMore" slot="reference" >
                                {{scope.row.info.length>280?scope.row.info.substr(0,270)+'...':scope.row.info}}
                            </a>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column prop="minId" width="100" align="center"  label="订单最小ID"> </el-table-column>
                <el-table-column prop="maxId" width="100" align="center"  label="订单最大ID"> </el-table-column>

                <el-table-column prop="createTime" width="160" align="center"  label="执行开始时间"> </el-table-column>
                <el-table-column prop="overTime" width="160" align="center"  label="执行结束时间"> </el-table-column>


            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </el-card>
        <!-- 新建自主表名弹出框 -->
        <el-dialog :close-on-click-modal="false" title="添加" :visible.sync="addVisible" :modal-append-to-body='false' top="80px" width="500px">
            <el-form ref="form1" :model="form1" label-width="80px" @submit.native.prevent="saveForm">
                <el-form-item required label="表名代码">
                    <el-input v-model.trim="form1.code"  placeholder="不超过10个字" class="w100"></el-input>
                </el-form-item>
                <el-form-item required label="表名说明">
                    <el-input v-model.trim="form1.name"  placeholder="不超过10个字" class="w100"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">{{ isSubmitting ? '提交中...' : '提 交' }}</el-button>
            </span>
        </el-dialog>



        <!-- 编辑自主表名弹出框 -->
        <el-dialog :close-on-click-modal="false" title="编辑" :visible.sync="editVisible" :modal-append-to-body='false' top="50px" width="500px">
            <el-form ref="form" :model="form2" label-width="80px">
                <el-form-item required label="表名代码">
                    <el-input v-model.trim="form2.code"  placeholder="不超过10个字" class="w100"></el-input>
                </el-form-item>
                <el-form-item required label="表名说明">
                    <el-input v-model.trim="form2.name"  placeholder="不超过10个字" class="w100"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="批量修改" :visible.sync="updateMoreVisible" :modal-append-to-body='false'  top="50px" width="500px">
            <el-form ref="form" :model="form3" label-width="80px">
                <el-form-item required label="表名说明">
                    <el-input v-model.trim="form3.name"  placeholder="不超过10个字" class="w100"></el-input>
                </el-form-item>
                <el-form-item required label="表名内容">
                    <el-input  type="textarea" v-model.trim="form3.content"  placeholder="不超过50个字" class="w100"></el-input>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateMoreVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveUdateMore">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import {fetchData,saveForm,handDelete,handDeleteMore,changeForm,changeStatus,handUpdateMore} from './comTableHis';
export default {
    data() {
        return {
            isSubmitting: false, // 是否正在提交
            select:{ option:'',  },
            query: {
                pageIndex: 1,
                pageSize: 10,
            },
            multipleSelection:[],
            tableData: [],
            pageTotal: 0,
            editVisible: false,
            addVisible: false,
            updateMoreVisible:false,
            form: {  },
            form1: {  },
            form2: {   },
            form3: {   },
            id: -1
        };
    },
    created() {

    },
    //页面加载方法
    mounted: function () {
        //查询列表
        this.getData();
    },

    methods: {
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){
            this.$set(this.query, 'yearMonth', '');
            this.$set(this.query, 'status');
            this.$set(this.query, 'code');
            this.handleSearch();
        },
        //触发刷新按钮
        refresh(){
            history.go(0);
        },

        //查询
        getData(){
            this.multipleSelection = [];
            fetchData(this.query).then(res => {
                if(res.code=='200'){
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;
                }else{
                    this.tableData = [];
                    this.pageTotal = 0;
                }

            });
        },


        // 添加表名
        handleAdd() {
            this.addVisible = true;
        },
        //保存添加
        saveForm() {
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            if( !this.form1.code ){
                this.isSubmitting = false;
                this.$message.error("请填写表名代码");
                return;
            }
            if( !this.form1.name ){
                this.isSubmitting = false;
                this.$message.error("请填写表名说明");
                return;
            }

            this.loading = true;
            this.addVisible = false;
            saveForm(this.form1).then(res => {
                this.addVisible = false;
                this.loading = false;
                this.isSubmitting = false;
                if(res.code=='200'){
                    this.$message.success(res.message);
                    this.refreshSearch();
                }else{
                    this.$message.error(res.message);
                }
            });
        },

        // 编辑操作
        handleEdit(index, row) {
            this.editVisible = true;
            this.form2 = row;
        },
        // 保存更改
        saveEdit() {
            changeForm(this.form2).then(res => {
                if(res.code=='200'){
                    this.editVisible = false;
                    this.$message.success(res.message);
                    this.getData();
                }else{
                    this.$message.error(res.message);
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) {
            var tips ;
            var content;
            if(row.status=='0'){
                row.status='1'
                tips = "关闭";
                content = "确定关闭缓存吗？";
            }else{
                row.status='0'
                tips = "开启";
                content = "确定开启缓存吗？";
            }
            // 二次确认删除
            this.$confirm(content, '提示', {
                type: 'warning'
            }).then(() => {
                if(row.status=='0'){
                    row.status='1'
                }else{
                    row.status='0'
                }
                changeStatus(row).then(res => {
                    if(res.code=='200'){
                        this.$message.success(tips+'成功');
                        this.getData();
                    }else{
                        if(row.status=='0'){
                            row.status='1'
                        }else{
                            row.status='0'
                        }
                        this.$message.error(tips+'失败');
                    }
                });
            })
        },
        // 删除
        handDelete(index, row) {
            // 二次确认删除
            this.$confirm('该表名是否要删除？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(row).then(res => {
                    if(res.code=='200'){
                        this.$message.success('删除成功');
                        this.$set(this.query, 'pageIndex', 1);
                        this.getData();
                    }else if(res.code=='201'){
                        //处理该等级绑定的成员
                        this.$message.error("该表名仍有订单未结算，请手动结算订单！");
                    }else{
                        this.$message.error("删除失败");
                    }
                });
            })
        },

        // 批量修改
        updateMore(){
            if(this.multipleSelection.length===0){
                this.$message.error("请勾选需要批量修改的数据");
                return;
            }
            this.updateMoreVisible = true;
        },
        saveUdateMore(){
            var ids = '';
            for (let i = 0; i < this.multipleSelection.length; i++) {
                ids += this.multipleSelection[i].id + ',';
            }
            this.form3.id = ids.substring(0,ids.length-1);
            this.updateMoreVisible = false;
            handUpdateMore(this.form3).then(res => {
                if(res.code=='200'){
                    this.$message.success('批量修改成功');
                    this.handleSearch();
                }else{
                    this.updateMoreVisible = true;
                    this.$message.error(res.message );
                }
            });
        },
        //批量删除
        deleteMore(){
            if(this.multipleSelection.length ===0){
                this.$message.error("请勾选需要批量删除的数据");
                return;
            }
            this.$confirm('确认要进行批量删除操作吗？', '提示', {
                type: 'warning'
            }).then(() => {
                var ids = '';
                for (let i = 0; i < this.multipleSelection.length; i++) {
                    ids += this.multipleSelection[i].id + ',';
                }
                ids = ids.substring(0,ids.length-1);
                handDeleteMore({ id:ids }).then(res => {
                    if(res.code=='200'){
                        this.$message.success('批量删除成功');
                        this.handleSearch();
                    }else{
                        this.$message.error(res.message );
                    }
                });
            })

        },


        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val) {
            this.$set(this.query, 'pageSize', val);
            this.handleSearch();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
    }
};
</script>

<style scoped>

</style>
